module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Predator-The.cdde9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Predator-The.jpg
// module id = 7mi2
// module chunks = 0